// NPM
import { Guid } from "guid-typescript";
import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
import { PAReviewModule } from "@/store/modules/paReview.module";
const paReviewListingMachine = Machine({
    id: "paReviewListingMachine",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "cycleName",
                type: "none",
            },
            columnFilters: [],
            operatingStepId: "",
            cycleFilters: null,
            showActionableItem: false,
        },
        stepTabs: [],
    },
    initial: "idle",
    states: {
        idle: {
            always: { target: "getReviewStepTabs" },
        },
        getReviewStepTabs: {
            invoke: {
                id: "getReviewStepTabs",
                src: (context, event) => {
                    return PAReviewModule.GetReviewStepTabs();
                },
                onDone: [
                    {
                        target: "loadedStepTabs",
                        cond: (context, event) => event.data.length > 0,
                        actions: "setOperatingStepId",
                    },
                    {
                        target: "noReviews",
                        cond: (context, event) => event.data.length == 0,
                    },
                ],
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedStepTabs: {
            on: {
                GETTING_REVIEWS: [
                    { target: "gettingReviews", actions: "setSearchData", cond: "hasStepsBeenLoaded" },
                    { target: "getReviewStepTabs", actions: "setSearchData", cond: "firstLoad" },
                ],
            },
        },
        gettingReviews: {
            always: { target: "loadedReviews", cond: "isOperatingIdEmpty" },
            invoke: {
                id: "gettingReviews",
                src: (context, event) => {
                    if (PAReviewModule.stepTabs.find((x) => x.stepId == context.searchData.operatingStepId).canGroupByCycles) {
                        return PAReviewModule.GetReviewCycles(context.searchData);
                    }
                    else {
                        return PAReviewModule.GetReviews(context.searchData);
                    }
                },
                onDone: { target: "loadedReviews" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedReviews: {
            on: {
                GETTING_REVIEWS: { target: "gettingReviews", actions: "setSearchData" },
                SHOW_REVIEW_MEETING_STATUS: { target: "fetchingReviewsStatus" },
            },
        },
        fetchingReviewsStatus: {
            invoke: {
                id: "reviewsSummary",
                src: (context, event) => {
                    return PAReviewModule.GetCycleSummary({ cycleId: event.cycleId, stepId: context.searchData.operatingStepId });
                },
                onDone: { target: "loadedReviewsStatus" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedReviewsStatus: {
            on: {
                CLOSE_CYCLE_SUMMARY: { target: "loadedReviews" },
            },
        },
        noReviews: {
            tags: "noReviews",
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        setOperatingStepId: assign({
            stepTabs: (context, event) => event.data,
            searchData: (context, event) => {
                if (PAReviewModule.operatingStepId && event.data && event.data.some((x) => x.stepId == PAReviewModule.operatingStepId)) {
                    context.searchData.operatingStepId = PAReviewModule.operatingStepId;
                }
                else {
                    context.searchData.operatingStepId = event.data[0]?.stepId;
                    PAReviewModule.SetOperatingStepId(context.searchData.operatingStepId);
                }
                return context.searchData;
            },
        }),
        setSearchData: assign({
            searchData: (context, event) => {
                console.log("setting search data in machine context: ", event.searchData);
                PAReviewModule.SetOperatingStepId(event.searchData.operatingStepId);
                return event.searchData;
            },
        }),
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignSearchData: assign({
            searchData: (context, event) => {
                console.log("assigning search data in machine context: ", event.searchData);
                return event.searchData;
            },
        }),
    },
    guards: {
        firstLoad: (ctx) => ctx.stepTabs.length == 0,
        hasStepsBeenLoaded: (ctx) => ctx.stepTabs.length > 0,
        isOperatingIdEmpty: (ctx) => {
            if (ctx.searchData.operatingStepId && ctx.searchData.operatingStepId != Guid.EMPTY) {
                return false;
            }
            return true;
        },
    },
    activities: {},
    services: {},
});
export default paReviewListingMachine;
